
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ObtenerClientesTiendasEnAPI, ActualizarClientesTiendaEnAPI } from "../../action/actionCreatorsRequests"
import { traducirPagina, obtenerUsuario } from '../../librerias/funciones'

import {
    CloseOutlined,
    DeleteOutlined,
    EditOutlined,
    EyeOutlined,
    SearchOutlined
} from '@ant-design/icons';

import { Select, Col, Drawer, Card } from 'antd';
import { MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBBtn, MDBInput } from 'mdbreact';

import FichaCrudTienda from './FichaCrudTienda';

const { Option } = Select;
const MantenimientoTienda = ({ props, configApp }) => {
    const [hayRegristros, setHayRegristros] = React.useState(false);

    const [registosTabla, setRegistosTabla] = React.useState([])

    const [abrirFichaCatDocumento, setAbrirFichaCatDocumento] = React.useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = React.useState({});
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [textoBuscador, setTextoBuscador] = React.useState("");





    const actualizarTabla = () => {
        ObtenerClientesTiendas(0, 1, 1, "D", null, socioSeleccionado);
    }


    const ObtenerClientesTiendas = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, ID_SOCIO) => {
        ObtenerClientesTiendasEnAPI(REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, ID_SOCIO).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {

                licencia.REGISTROS.map((registro) => {
                    registro.VISIBLE = true;
                })

                setRegistosTabla(licencia.REGISTROS)
            } else {
                setRegistosTabla(null)

            }
        })
    }


    const modificarRegistro = (ID) => {
        ActualizarClientesTiendaEnAPI(2, { ID: ID, ID_SOCIO: socioSeleccionado }).then((licencia) => {
            actualizarTabla()

        })
    }



    const filtroLocalDeLaTabla = (textoAFiltrar, registros) => {
        let resultado = []

        if (textoAFiltrar.trim() !== "") {
            if (registros !== null) {

                let resultadoFiltro = registros.filter((item) => {
                    return item.CODIGO_CLIENTE_SOCIO.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.CORREO_RECEPCION_PEDIDOS.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.TANTO_PORCIENTO_INCREMENTO.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.TIPO_INTEGRACION_TIENDA.toUpperCase().includes(textoAFiltrar.toUpperCase())
                })

                if (resultadoFiltro.length > 0) {
                    resultado = resultadoFiltro;
                } else {
                    resultado = [];
                }
            }
        } else {
            resultado = registros;
        }
        return resultado
    }



    if (!hayRegristros && props.ABRIR_FICHA) {
        setHayRegristros(true);

        let accesoLicencia = obtenerUsuario();
        let SOCIO_ACTUAL = accesoLicencia.SOCIOS[0].ID_SOCIO;

        setSociosLocal(accesoLicencia.SOCIOS)

        if (props.ID_SOCIO !== 0) {
            SOCIO_ACTUAL = props.ID_SOCIO;
        }

        setSocioSeleccionado(SOCIO_ACTUAL)
        ObtenerClientesTiendas(0, 1, 1, "D", null, SOCIO_ACTUAL);

    } else {
        if (!props.ABRIR_FICHA && hayRegristros) {
            setRegistosTabla([])
            setHayRegristros(false)
        }
    }


    return (
        <div>
            <Drawer
                width={1300}
                onClose={() => {
                    if (props.TIPO === "MASTER") {
                        props.CERRAR.setState({ ABRIR_FICHA_TIENDA: false })
                    } else {
                        props.CERRAR_FICHA(false)
                    }
                }}
                visible={props.ABRIR_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>


                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => {
                            if (props.TIPO === "MASTER") {
                                props.CERRAR.setState({ ABRIR_FICHA_TIENDA: false })
                            } else {
                                props.CERRAR_FICHA(false)
                            }
                        }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>


                <div className="p-3" style={{ height: (configApp.height - 70).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>


                    <div className="centerMenu3">
                        <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', height: '40px', justifyContent: 'space-between' }}>

                            <div style={{ textAlign: 'left' }} className="mdb-skin">

                                <div className="grid-container" style={{ backgroundColor: '#eee', marginRight: '10px' }}>
                                    <div className="grid-item">
                                        <input className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Buscar")} style={{ backgroundColor: "transparent", width: '310px', border: '0px', height: '100%', color: '#000' }} name="txtInputCliente" autoComplete="off" onChange={(e) => {

                                            setTextoBuscador(e.target.value)

                                            let result = filtroLocalDeLaTabla(e.target.value, registosTabla);
                                            console.log("Result", result)

                                            registosTabla.map((registro) => {
                                                const buscar = result.find((item) => item.ID === registro.ID)
                                                if (buscar === undefined) {
                                                    registro.VISIBLE = false;
                                                } else {
                                                    registro.VISIBLE = true;

                                                }
                                            })

                                            setRegistosTabla([...registosTabla])


                                        }} value={textoBuscador} />
                                    </div>

                                    <div className="grid-item" >
                                        <button style={{ border: '0', padding: '6px 5px 5px 7px', margin: '0', boxShadown: 'none', visibility: textoBuscador.trim() === "" ? 'hidden' : 'visible' }} className="btn-matriculav2" onClick={(e) => {
                                            setTextoBuscador("");

                                            if (registosTabla !== null) {
                                                registosTabla.map((registro) => {
                                                    registro.VISIBLE = true;
                                                })

                                                setRegistosTabla([...registosTabla])
                                            }



                                        }}>  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                                    </div>

                                    <div className="grid-item barraLateral" ></div>

                                    <div className="grid-item">
                                        <button onClick={e => { }} style={{ border: '0', padding: '6px 1px 5px 7px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </button>
                                    </div>
                                </div>


                                {

                                    sociosLocal !== null && !props.METODO_ALTA &&
                                    <Select
                                        showSearch
                                        allowClear={true}
                                        size={"large"}

                                        value={socioSeleccionado === 0 ? <span style={{ color: '#999' }}>{traducirPagina("Seleccione_socio").toUpperCase()}</span> : socioSeleccionado}

                                        style={{ width: "400px", textAlign: 'left', marginRight: '10px' }}
                                        optionFilterProp="children"
                                        onChange={(e) => {

                                            let SOCIO_ACTUAL = e === undefined || e === null ? 0 : parseInt(e);

                                            setSocioSeleccionado(SOCIO_ACTUAL);

                                            ObtenerClientesTiendas(0, 1, 1, "D", null, SOCIO_ACTUAL);

                                            setTextoBuscador("");



                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {sociosLocal.length > 0 ?
                                            sociosLocal.map((socio) =>
                                                <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                            )
                                            :
                                            null
                                        }
                                    </Select>

                                }

                            </div>

                            <div className={"botonNuevo"} style={{ backgroundColor: 'var(--azul-claro-serca)', color: 'rgb(255, 255, 255)' }} onClick={() => {
                                setRegistroSeleccionado({ ID: 0 });
                                setAbrirFichaCatDocumento(true);



                            }}>  <span style={{ fontSize: '16px' }}>{traducirPagina("Nueva_tienda").toUpperCase()}</span>
                            </div>


                        </div>
                    </div>



                    <Card style={{ height: (configApp.height - 170).toString() + "px" }} className="mb-2 mt-3 mdb-skin" >
                        {registosTabla === null ?
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Sin_resultados")}</h4>
                            </div>
                            :
                            registosTabla.length > 0 ?
                                <div style={{ fontSize: '16px', fontWeight: '500', color: "#000", height: (configApp.height - 225).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }} className="row">
                                    <MDBTable responsive hover >
                                        <MDBTableHead>
                                            <tr>
                                                <th style={{ width: '30px', paddingLeft: 0, fontSize: "14px", fontWeight: "bold", verticalAlign: 'baseline', cursor: 'pointer' }} >
                                                    {"Id"}
                                                </th>
                                                <th style={{ width: '75px', paddingLeft: 0, fontSize: "14px", fontWeight: "bold", verticalAlign: 'baseline', cursor: 'pointer' }} >
                                                    {traducirPagina("Codigo")}
                                                </th>

                                                <th style={{ width: '120px', paddingLeft: 0, fontSize: "14px", fontWeight: "bold", verticalAlign: 'baseline', cursor: 'pointer' }} >{traducirPagina("Nombre")}  </th>
                                                <th style={{ width: '160px', paddingLeft: 0, fontSize: "14px", fontWeight: "bold", verticalAlign: 'baseline', cursor: 'pointer' }}>{traducirPagina("Tipo_tienda")} </th>
                                                <th style={{ width: '90px', paddingLeft: 0, fontSize: "14px", fontWeight: "bold", verticalAlign: 'baseline', textAlign: 'right' }}>{traducirPagina("Porcentaje_incremento")}</th>
                                                <th style={{ width: '50px', paddingLeft: 0, fontSize: "14px", fontWeight: "bold", textAlign: 'right' }} onClick={(e) => { }}>{ } </th>

                                            </tr>
                                        </MDBTableHead>
                                        <MDBTableBody>
                                            {registosTabla.map((cliente, i) =>
                                                <tr key={i} >
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }} onClick={(e) => { props.MODO_SELECCION && props.METODO_ALTA(cliente) }}>{cliente.ID}</td>

                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }} onClick={(e) => { props.MODO_SELECCION && props.METODO_ALTA(cliente) }}>{cliente.CODIGO_CLIENTE_SOCIO}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }} onClick={(e) => { props.MODO_SELECCION && props.METODO_ALTA(cliente) }}>{cliente.NOMBRE}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle' }} onClick={(e) => { props.MODO_SELECCION && props.METODO_ALTA(cliente) }}>{cliente.TIPO_INTEGRACION_TIENDA}</td>
                                                    <td style={{ paddingLeft: 0, fontSize: "14px", verticalAlign: 'middle', textAlign: 'right' }}>{cliente.TANTO_PORCIENTO_INCREMENTO}</td>

                                                    {<td style={{ paddingLeft: 0, fontSize: "14px", textAlign: 'right' }}>
                                                        <div className="flex-container-Grow-Simple" style={{ justifyContent: 'end' }}>

                                                            <div style={{ margin: '0px 2px' }}>
                                                                <button title={"Editar"} onClick={() => {
                                                                    // window.open("http://sertec.servicenext.eu//?user=" + licencia.USUARIO + "&pass=" + licencia.PWD, '_blank');
                                                                    setRegistroSeleccionado(cliente)
                                                                    setAbrirFichaCatDocumento(true)
                                                                }}
                                                                    className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                                    <EditOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                                </button>
                                                            </div>



                                                            <div style={{ margin: '0px 2px' }} >
                                                                <button title={"Eliminar"} onClick={() => {

                                                                    // MailDeRecuperacion(licencia.ID);
                                                                    modificarRegistro(cliente.ID, "", "")
                                                                }}
                                                                    className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                                    <DeleteOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                                </button>
                                                            </div>


                                                        </div>
                                                    </td>}

                                                </tr>
                                            )}
                                        </MDBTableBody>
                                    </MDBTable>
                                </div>

                                :
                                <div style={{ fontSize: '16px', fontWeight: '500', color: "#000" }} className="row">
                                    <MDBCol md="9">
                                        <div>
                                            <span className="skeleton-box" style={{ width: '900px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '900px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                            <br />
                                            <span className="skeleton-box" style={{ width: '800px' }}></span>
                                        </div>
                                    </MDBCol>
                                </div>
                        }
                    </Card>

                </div>
            </Drawer>



            {abrirFichaCatDocumento ?
                <FichaCrudTienda
                    title={traducirPagina("Tienda").toUpperCase()}
                    ABRIR_FICHA={abrirFichaCatDocumento}
                    CERRAR_FICHA={setAbrirFichaCatDocumento}

                    REGISTROS={registroSeleccionado}
                    ID_REGISTRO={registroSeleccionado.ID}
                    ID_SOCIO={socioSeleccionado}
                    ACTUALIZAR_TABLA={actualizarTabla}

                >
                </FichaCrudTienda>
                :
                null}


        </div>

    )
}



MantenimientoTienda.propTypes = {
    title: PropTypes.string,


    TIPO: PropTypes.string,
    CERRAR: PropTypes.object,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,



    ID_SOCIO: PropTypes.number,
    MODO_SELECCION: PropTypes.bool,
    METODO_ALTA: PropTypes.func,



};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,

    };
}

export default connect(mapStateToProps)(MantenimientoTienda);